import {space} from "../compiled";
import IPractitionerProto = space.kenko.proto.IPractitionerProto;
import IServiceProto = space.kenko.proto.IServiceProto;


export const providerOffersService = (service: IServiceProto, practitionerId: string | null | undefined) => {

  console.log(JSON.stringify(service));
  
  if (!service.practitionerId || !practitionerId) {
    return false;
  }

  return service.practitionerId.indexOf(practitionerId) >= 0;
}

export const findPractitioner = (practitioners: IPractitionerProto[] | null | undefined,
                                 practitionerId: string | null | undefined): IPractitionerProto | null => {

  if (!practitioners) {
    return null;
  }

  const index = findPractitionerIndex(practitioners, practitionerId);
  return index < 0 ? null : practitioners[index];
}


const findPractitionerIndex = (practitioners: IPractitionerProto[] | null | undefined,
                                      practitionerId: string | null | undefined): number => {

  if (!practitionerId || !practitioners?.length) {
    return -1;
  }

  for (let i = 0; i < practitioners.length; i++) {
    if (practitioners[i].practitionerId == practitionerId) {
      return i;
    }
  }

  return -1;
}